"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.accessScopeLabel = accessScopeLabel;
/** "All ACOs · PHI", "VBLTC1, VBLTC2", "No ACO"; "…" while the access is not read yet. */
function accessScopeLabel(access) {
    if (access === undefined)
        return "…";
    const acos = access.allAcos
        ? "All ACOs"
        : access.acos.length > 0
            ? access.acos.join(", ")
            : "No ACO";
    return access.phiAccess ? `${acos} · PHI` : acos;
}
//# sourceMappingURL=access-scope.js.map